try {
  // function isValidDomain(origin, customDomain = '') {
  //   // Domain and api domain
  //   const params = new URLSearchParams(window.location.search);
  //   const env = params.get('env') || '';
  //   let allowedOrigins = [
  //     'https://www.gevme.com',
  //     'https://showcase-dev.gevme.com',
  //     'https://showcase-dev.gev.me',
  //     'https://showcase.gev.me',
  //     'https://live.gev.me',
  //     'https://live-dev.gevme.com',
  //     'https://live.gevme.com',
  //     'https://admin.gevme.com',
  //     'https://admin.gev.me',
  //     'https://admin-dev.gevme.com',
  //   ];

  //   if (
  //     (process.env.NODE_ENV === 'development' ||
  //       process.env.NODE_ENV === 'LOCAL') &&
  //     env === 'localhost'
  //   ) {
  //     allowedOrigins.push('http://localhost:3001');
  //   }

  //   if (customDomain) {
  //     allowedOrigins.push(customDomain);
  //   }

  //   return allowedOrigins.some((domain) => origin === domain);
  // }

  function handleMessageChat(event) {
    try {
      if (isValidDomain(event.origin, window?.GEVME?.setting?.customDomain)) {
        const dataObj = JSON.parse(event.data);
        var chat = document.querySelector('iframe#GevmeChat');
        if (dataObj && dataObj.open) {
          chat.classList.add('chat-open');
          chat.classList.remove('chat-close');

          if (dataObj.position && dataObj.position === 'left') {
            chat.style =
              'position: fixed; z-index: 1; left: 0; right: unset; top: 0px; bottom: 0px; margin: auto; transition: all 0.3s ease;';
          } else {
            chat.style =
              'position: fixed; z-index: 1; left: unset; right: 0; top: 0px; bottom: 0px; margin: auto; transition: all 0.3s ease;';
          }
        }

        if (dataObj && !dataObj.open && typeof dataObj.open !== 'undefined') {
          chat.classList.add('chat-close');
          chat.classList.remove('chat-open');
          chat.style = `position: fixed; z-index: 1; left: ${
            dataObj.position === 'left' ? '-200%' : 'unset'
          }; right: -200%;
        }; top: 0px; bottom: 0px; margin: auto; transition: all 0.3s ease;`;
        }
      }
    } catch (error) {
      console.error(error);
    }
  }
  class GevmeChat extends HTMLElement {
    constructor() {
      super();
    }

    windowEventListener() {
      window.addEventListener('message', handleMessageChat);
    }

    connectedCallback() {
      var settings = JSON.parse(this.getAttribute('settings'));
      var iframe = document.createElement('iframe'),
        redirectBaseURI = `${
          window?.GEVME?.setting?.customDomain ||
          process.env.TEMPLATE_APP_DOMAIN
        }/widgets`;

      iframe.id = 'GevmeChat';
      iframe.name = 'GevmeChat';
      iframe.title = 'GEVME Chat';
      iframe.sandbox =
        'allow-scripts allow-forms allow-popups allow-downloads allow-modals allow-presentation allow-same-origin';
      iframe.allowFullScreen = true;
      iframe.seamless = true;
      iframe.loading = 'lazy';
      iframe.referrerPolicy = 'no-referrer';
      iframe.src =
        `${redirectBaseURI}/chat?s=${encodeURI(JSON.stringify(settings))}` +
        `&slug=${window?.GEVME?.livepage?.slug}` +
        `${window?.GEVME?.isPreview ? '&isPreview=true' : ''}`;
      iframe.width = settings?.width || '300px';
      iframe.height = settings?.height || '100%';
      iframe.frameBorder = '0';
      iframe.style = `position: fixed; z-index: 1; left: 0; right: -200%; top: 0; bottom: 0; visibility: hidden;`;

      iframe.onload = function () {
        try {
          if (settings.position && settings.position === 'left') {
            iframe.style = `position: fixed; z-index: 1; left: -200%; right: unset; top: 0; bottom: 0; margin: auto; transition: all 0.3s ease;`;
          } else {
            iframe.style = `position: fixed; z-index: 1; right: -200%; left: unset; top: 0; bottom: 0; margin: auto; transition: all 0.3s ease;`;
          }
          this.contentWindow.postMessage(
            JSON.stringify({
              action: 'gevme-json',
              data: JSON.stringify(window.GEVME),
            }),
            '*'
          );
        } catch (error) {
          console.error(error);
        }
      };

      while (this.attributes.length > 0)
        this.removeAttribute(this.attributes[0].name);

      this.append(iframe);
      this.windowEventListener();
    }
  }
  window.customElements.define('gevme-chat', GevmeChat);
} catch (error) {
  console.error(error);
}
